import {FILTER_KEY_ALL} from "../../ducks/assets-duck.js";

export const FILTER_KEY_GLOBAL = 'global'

export const filterAnnotations = (annotations, filterId, assetId) =>
    annotations.filter(annotation => {
        if(assetId){
            return parseInt(assetId) === annotation.asset_id
        }
        if(filterId === FILTER_KEY_GLOBAL){
            return !annotation.category_id && !annotation.asset_id
        }
        return filterId === FILTER_KEY_ALL || annotation.category_id === filterId
    }).reverse()